<div class="modal-container" *ngIf="systemAccessShow">
    <div class="modal-header">
        <h2 class="modal-title">
            <span>{{globalConstants.REVOKE_SYS_ACCESS_REVOKE_SYS_ACCESS}}</span>
        </h2>
        <div class="pull-right d-flex align-items-center">
            <button type="button" class="btn btn-text-orange me-4" (click)="showViewHistoryModal()" aria-label="Close"
                [disabled]="radioValue !== 'mySelf' && !revokeSystemAccessform.value['staffName']">
                {{globalConstants.VIEW_HISTORY_REVOKE_SYS_ACCESS}}
            </button>
            <button type="button" class="close btn-close" (mousedown)="onClose()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
    <div class="modal-body system-access-modal">
        <form [formGroup]="revokeSystemAccessform" autocomplete="one-time-code">
            <div class="need-access-form-container">
                <div class="inline-input-container">
                    <div class="mt-3" *ngIf="accessData?.data?.personFlag === 'true'">
                        <label>{{globalConstants.STAFF_NAME_REVOKE_SYS_ACCESS}}:
                            {{accessData?.data?.personData?.firstName}}
                            {{accessData?.data?.personData?.lastName}}</label>
                    </div>
                    <div class="radio-input-wrapper" *ngIf="accessData?.data?.personFlag === 'false'">
                        <label for="radioInputs"
                            class="form-label form-label-custom">{{globalConstants.REVOKING_ACCESS_FOR_REVOKE_SYS_ACCESS}}<span
                                class="required-text">*</span></label>
                        <div class="radio-inputs" id="radioInputs">
                            <div class="form-check form-check-inline">
                                <label class="radio-label-wrap">
                                    <input class="form-check-input" type="radio" (change)="onItemChange($event)"
                                        name="requestTypeMode" id="mySelfRadio" value="mySelf"
                                        formControlName="requestTypeMode">
                                    <span class="form-check-text">{{globalConstants.MY_SELF_REVOKE_SYS_ACCESS}}</span>
                                </label>
                            </div>
                            <div class="form-check form-check-inline"
                                *ngIf="!nonEmployeeFlag && countData?.myStaffCount">
                                <label class="radio-label-wrap">
                                    <input class="form-check-input" type="radio" (change)="onItemChange($event)"
                                        name="requestTypeMode" id="myStaffRadio" value="myStaff"
                                        formControlName="requestTypeMode">
                                    <span class="form-check-text">{{globalConstants.MY_STAFF_REVOKE_SYS_ACCESS}}</span>
                                </label>
                            </div>
                            <div class="form-check form-check-inline"
                                *ngIf="!nonEmployeeFlag && countData?.myDepartmentCount">
                                <label class="radio-label-wrap">
                                    <input class="form-check-input" type="radio" (change)="onItemChange($event)"
                                        name="requestTypeMode" id="departmentRadio" value="myDepartment"
                                        formControlName="requestTypeMode">
                                    <span
                                        class="form-check-text">{{globalConstants.MY_DEPARTMENT_REVOKE_SYS_ACCESS}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="search-input-container" *ngIf="radioValue !== 'mySelf'">
                    <div class="search-input-wrapper">
                        <label for="nameSearch" class="form-label form-label-custom">{{globalConstants.STAFF_NAME_REVOKE_SYS_ACCESS}}<span class="required-text">*</span></label>
                        <div class="search-input-btn-wrap">
                            <input type="text" class="form-control form-control-custom" id="nameSearch" placeholder="Search or Enter">
                            <button type="button" class="btn btn-text-orange">{{globalConstants.SEARCH_REVOKE_SYS_ACCESS}}</button>
                        </div>
                    </div>
                </div>
                <div class="required-info" *ngIf="radioValue === 'mySelf'"><span class="required-text">*</span>Indicates required field</div> -->
                </div>

                <div class="row" *ngIf="radioValue !== 'mySelf'">
                    <div class="col-md-6 col-lg-3">
                        <div class="multiselect-dropdown-container mt-30">
                            <label for="nameSearch"
                                class="form-label form-label-custom">{{globalConstants.STAFF_NAME_REVOKE_SYS_ACCESS}}<span
                                    class="required-text">*</span></label>
                            <div class="multiselect-dropdown-wrap">
                                <ng-select [items]="staffList" bindLabel="fullName" bindValue="personId"
                                    formControlName="staffName" placeholder="Select" (change)="getAppDetails()">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div title="{{item.fullName}}">{{item.fullName}}</div>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="radioValue === 'mySelf'">
                    <div class="col-md-6 col-lg-3">
                        <div class="multiselect-dropdown-container mt-30">
                            <label for="nameSearch"
                                class="form-label form-label-custom">{{globalConstants.SYS_NEED_ACCESS_FOR_REVOKE_SYS_ACCESS}}
                                <span class="required-text">*</span></label>
                            <div class="multiselect-dropdown-wrap">
                                <ng-multiselect-dropdown [settings]="settings" [data]="appList" idField="appId"
                                    formControlName="selectedApps">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="radioValue !== 'mySelf' && revokeSystemAccessform.value['staffName']">
                    <div class="col-md-6 col-lg-3">
                        <div class="multiselect-dropdown-container mt-30">
                            <label for="nameSearch"
                                class="form-label form-label-custom">{{globalConstants.SYS_NEED_ACCESS_FOR_REVOKE_SYS_ACCESS}}
                                <span class="required-text">*</span></label>
                            <div class="multiselect-dropdown-wrap">
                                <ng-multiselect-dropdown [settings]="settings" [data]="appList" idField="appId"
                                    formControlName="selectedApps">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="textarea-input-wrap mt-30">
                    <label for="nameSearch"
                        class="form-label form-label-custom">{{globalConstants.PLS_JUST_WHY_NOT_NEED_ACCESS_REVOKE_SYS_ACCESS}}
                        <span class="required-text">*</span></label>
                    <textarea class="form-control form-control-custom" id="exampleFormControlTextarea1" rows="3"
                        placeholder="Enter" formControlName="accessJustification" maxlength="500" #accessJustification
                        spellcheck="false" appTrim appCharOnlyWithspl></textarea>
                    <span class="text-limit">{{accessJustification.value.length}} /
                        {{globalConstants._500_CHARACTER_LEFT_REVOKE_SYS_ACCESS}} </span>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer d-flex justify-content-end">
        <button class="btn btn-outline" (click)="clearForm()">{{globalConstants.CLEAR_REVOKE_SYS_ACCESS}}</button>
        <button type="submit" class="btn btn-orange" (click)="openConfirmModal('Suspend')"
            [disabled]="!getFormValidStatus()">{{globalConstants.SUSPEND_REVOKE_SYS_ACCESS}}</button>
        <button type="submit" class="btn btn-orange" (click)="openConfirmModal('Revoke')"
            [disabled]="!getFormValidStatus()">{{globalConstants.REVOKE_REVOKE_SYS_ACCESS}}</button>
    </div>
</div>